import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useSelector } from 'react-redux';
import type { RootState } from '../../types/store';

type GameCategoryInfoDisplayProps = {
    gameMode: number;
}

export default function GameCategoryInfoDisplay({gameMode} : GameCategoryInfoDisplayProps) {
    const translate = useSelector((state:RootState) => state.ui.language);
    const settings = useSelector((state:RootState) => state.settings);
    const theme = useTheme();

    const filteredCategories = settings.categories.flatMap((category) => {
        if(category.availableModes.includes(gameMode)) {
            const match = translate.categories.find(c => c.id === category.id);
            if (match) {
                return [{ id: category.id, icon: category.icon, name: match.name, description: match.description }];
            }
        }
        return [];
    });
    
    return (
        <Box minHeight={"40rem"} display="flex" flexDirection={"column"} justifyContent={"center"} alignItems={"center"} padding={2}>
            <Stack gap={4}>
                {filteredCategories.map((info) => {

                    return (<div key={info.id}>
                        <Typography color={theme.palette.primary.light} fontWeight={600}>
                            {info.name}
                        </Typography>
                        <Typography sx={{ width: "80%" }} color={theme.palette.secondary.light}>
                            {info.description}
                        </Typography>
                    </div>);
                })}
            </Stack>
        </Box>
    );
}
